module.exports = __webpack_public_path__ + "static/media/fusion-ginssen-icon-03.0849192d.png";